import React, { useEffect, useState } from 'react';
import { signupApi, type SignupStatusResponse } from 'features/frictionless-signup/services/signupApi';
import RunnerStatusDisplay from 'components/RunnerStatusDisplay';

const RunnersView: React.FC = () => {
  const [signupStatus, setSignupStatus] = useState<SignupStatusResponse | null>(null);
  const [isLoadingSignupStatus, setIsLoadingSignupStatus] = useState(true);

  useEffect(() => {
    const fetchSignupStatus = async (): Promise<void> => {
      try {
        setIsLoadingSignupStatus(true);
        const status = await signupApi.getCurrentUserSignupStatus();
        setSignupStatus(status);
      } catch (err) {
        console.error('Failed to fetch signup status:', err);
        setSignupStatus(null);
      } finally {
        setIsLoadingSignupStatus(false);
      }
    };

    void fetchSignupStatus();
  }, []);

  return (
    <div className="flex h-full w-full flex-col bg-dashboard-background">
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">
        <div className="sm:flex sm:items-center mb-8">
          <div className="sm:flex-auto">
            <h1 className="text-2xl text-dataops-dark">DataOps Runners</h1>
            <p className="mt-2 text-sm text-secondary-text">View the status of your DataOps runner configuration.</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          {isLoadingSignupStatus ? (
            <div className="text-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-dataops-primary-blue mx-auto"></div>
              <p className="text-sm text-secondary-text mt-3">Loading runner status...</p>
            </div>
          ) : signupStatus === null ? (
            <div className="text-center py-8">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                />
              </svg>
              <h3 className="mt-2 text-sm text-dataops-dark">Runners managed by your organization</h3>
              <p className="mt-1 text-sm text-secondary-text">
                Your DataOps runners are managed by your organization. Contact your administrator for more information.
              </p>
            </div>
          ) : (
            <RunnerStatusDisplay status={signupStatus?.current_step ?? null} />
          )}
        </div>
      </div>
    </div>
  );
};

export default RunnersView;
